var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{ref:"input",attrs:{"placeholder":_vm.$lang.configurationEditor.pleaseInputUrl},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}},[_c('el-button',{attrs:{"slot":"append","icon":"el-icon-upload","loading":_vm.uploading},on:{"click":_vm.handleUpload},slot:"append"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }